
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 9 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M7.28.407c-1.004.218-3.025.605-5.107 2.25C.188 4.221.304 6.568.457 7.544a.976.976 0 00.01.054.374.374 0 01-.025.228C-.02 8.909-.16 9.983.258 10.944c.033.074.097.13.18.16.083.03.182.032.28.005l.503-.138a.592.592 0 00.191-.094.547.547 0 00.141-.151.414.414 0 00.062-.178.306.306 0 00-.03-.168c-.265-.522-.332-1.108-.203-1.769a.261.261 0 01.097-.15.306.306 0 01.176-.066h.003c1.258-.057 3.65-.455 5.106-2.677C8.14 3.616 8.134 1.831 8.136.963c.001-.756-.221-.695-.857-.556z"}})])
          )
        }
      }
    